import React, { useState, useEffect } from 'react';

/* Część osób ma zawroty głowy przy tekście pojawiającym się literami,
   a systemowe „ogranicz ruch" jest deklaracją takiej potrzeby.
   Sprawdzamy je leniwie, bo w prerenderze nie ma window. */
const wolniejBezRuchu = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const Typewriter = ({ text, typingSpeed = 100, onTypingEnd }) => {
  const [reduceMotion] = useState(wolniejBezRuchu);
  const [displayedText, setDisplayedText] = useState(reduceMotion ? text : '');

  useEffect(() => {
    /* Przy wyłączonych animacjach pokazujemy cały tekst od razu.
       onTypingEnd wołamy z efektu, nie w trakcie renderu - inaczej
       aktualizowalibyśmy stan rodzica podczas jego renderowania. */
    if (reduceMotion) {
      setDisplayedText(text);
      if (onTypingEnd) onTypingEnd();
      return undefined;
    }

    let currentIndex = 0;
    const interval = setInterval(() => {
      setDisplayedText(text.substring(0, currentIndex + 1));
      currentIndex++;
      if (currentIndex === text.length) {
        clearInterval(interval);
        if (onTypingEnd) {
          onTypingEnd(); // Wywołujemy callback po zakończeniu pisania
        }
      }
    }, typingSpeed);

    return () => clearInterval(interval);
  }, [text, typingSpeed, onTypingEnd, reduceMotion]);

  return (
    <div className="typewriter-container">
      {displayedText}
    </div>
  );
};

export default Typewriter;
